// GENEROWANE z opisu linii w workerze Go: `worker tool typy` (worker-go/tools/typy).
// Nie edytować ręcznie - zmiana kontraktu = zmiana opisu w Go i ponowne wygenerowanie (KN-2).

import type { ViewDoc } from "../kontrakt";

export interface PolaWedzarnia2 {
  chamber: number | null;
  chamber_ok: boolean | null;
  meat: number | null;
  elapsed_s: number | null;
  total_s: number | null;
  phase_no: number | null;
  stat: string | null;
  praca: "koniec" | "praca" | "stop" | null;
  recipe: string | null;
  heater: boolean | null;
  heater_pct: number | null;
  heater_kw: number | null;
  ctrl: "onoff" | "triac" | null;
  rssi: number | null;
  plus30: boolean | null;
  eta_state: "approaching" | "heating" | "ready" | "stall" | null;
  eta_min: number | null;
  rozgrzew_state: "warming" | "at_temp" | null;
  rozgrzew_min: number | null;
}

export interface NastawyWedzarnia2 {
  TDM: number | null;
  TWM: number | null;
  Czas: string | null;
  PROG: "MANUAL" | "SZYNKA" | "KIELBASA" | "KRAKOWSKA" | "RYBA" | "WLASNY" | "PRZEPIS" | null;
  DYM: number | null;
  FAN1: number | null;
  FAN2: number | null;
  LED: boolean | null;
  ocCW: number | null;
  osCW: number | null;
  wCW: number | null;
  pCW: number | null;
  tRW: number | null;
  tSW: number | null;
  tWW: number | null;
  tPW: number | null;
  tWMW: number | null;
  genAuto: boolean | null;
  heaterMode: 0 | 1 | null;
  hyst: number | null;
  fanLink: boolean | null;
  KTD: number | null;
  KTW: number | null;
  lang: "PL" | "EN" | "CZ" | null;
}

/** Stan procesu w widoku (`state`) - etykiety z opisu procesu linii. */
export type StanWedzarnia2 = "KIELBASA" | "KRAKOWSKA" | "MANUAL" | "PRZEPIS" | "RYBA" | "SZYNKA" | "WLASNY";

export interface WidokWedzarnia2 extends Omit<ViewDoc, "fields" | "settings" | "no_sensor" | "state"> {
  type: "wedzarnia-2";
  state?: StanWedzarnia2;
  fields: PolaWedzarnia2;
  settings?: NastawyWedzarnia2;
  no_sensor?: Array<keyof PolaWedzarnia2>;
}

export const KOMENDY_WEDZARNIA2 = {
  "nastawy": {
    "Czas": {
      "rodzaj": "tekst",
      "wzorzec": "^([01][0-9]|2[0-3]):[0-5][0-9]$",
      "maks_dl": 5,
      "potwierdzenie": "timer",
      "poziom": "sterowanie"
    },
    "DYM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "FAN1": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "FAN2": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "KTD": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "KTW": {
      "rodzaj": "liczba",
      "min": -10,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "LED": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "PROG": {
      "rodzaj": "tekst",
      "opcje": [
        "MANUAL",
        "SZYNKA",
        "KIELBASA",
        "KRAKOWSKA",
        "RYBA",
        "WLASNY",
        "PRZEPIS"
      ],
      "maks_dl": 16,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "TDM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie",
      "szybkie": [
        60,
        70,
        80
      ]
    },
    "TWM": {
      "rodzaj": "liczba",
      "min": 0,
      "max": 100,
      "potwierdzenie": "echo",
      "poziom": "sterowanie",
      "szybkie": [
        63,
        68,
        72
      ]
    },
    "fanLink": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "genAuto": {
      "rodzaj": "wl_wyl",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "heaterMode": {
      "rodzaj": "lista",
      "wartosci": [
        0,
        1
      ],
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "hyst": {
      "rodzaj": "liczba",
      "min": 0.5,
      "max": 10,
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "lang": {
      "rodzaj": "tekst",
      "opcje": [
        "PL",
        "EN",
        "CZ"
      ],
      "maks_dl": 2,
      "potwierdzenie": "wyslano",
      "poziom": "restart"
    },
    "ocCW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "osCW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "pCW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tPW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tRW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tSW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tWMW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "tWW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    },
    "wCW": {
      "rodzaj": "liczba",
      "potwierdzenie": "echo",
      "poziom": "sterowanie"
    }
  },
  "akcje": {
    "autotune": {
      "poziom": "sterowanie"
    },
    "fabryczne": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    },
    "next": {
      "poziom": "sterowanie"
    },
    "panelPair": {
      "poziom": "sterowanie"
    },
    "plus30": {
      "tresci": [
        "0",
        "1"
      ],
      "poziom": "sterowanie"
    },
    "reset": {
      "poziom": "restart",
      "skutek": "online",
      "czas_s": 180
    },
    "resetWiFi": {
      "poziom": "niszczaca",
      "skutek": "parowanie",
      "czas_s": 60
    },
    "start": {
      "poziom": "sterowanie"
    },
    "stop": {
      "poziom": "sterowanie"
    }
  },
  "zestawy": {
    "program": {
      "pola": [
        "ocCW",
        "osCW",
        "wCW",
        "pCW",
        "tRW",
        "tSW",
        "tWW",
        "tPW",
        "tWMW"
      ],
      "poziom": "sterowanie"
    },
    "ustawienia": {
      "pola": [
        "genAuto",
        "heaterMode",
        "hyst",
        "fanLink",
        "KTD",
        "KTW"
      ],
      "poziom": "sterowanie"
    }
  },
  "czas_potwierdzenia_s": 10
} as const;

/** Pasek faz: `nr` = wartość pola `phase_no`. */
export const FAZY_WEDZARNIA2 = [
  {
    "nr": 1,
    "nazwa": "Ociekanie"
  },
  {
    "nr": 2,
    "nazwa": "Rozgrzewanie"
  },
  {
    "nr": 3,
    "nazwa": "Osuszanie"
  },
  {
    "nr": 4,
    "nazwa": "Rozpalanie"
  },
  {
    "nr": 5,
    "nazwa": "Wędzenie"
  },
  {
    "nr": 7,
    "nazwa": "Pieczenie"
  },
  {
    "nr": 8,
    "nazwa": "Koniec"
  }
] as const;

/** Kanały wykresu (numer w próbkach i w punkcie na żywo `widok.wykres`) z nazwą domyślną z opisu linii. */
export const KANALY_WEDZARNIA2 = [
  {
    "idx": 0,
    "nazwa": "Komora",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 1,
    "nazwa": "Wsad",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 2,
    "nazwa": "Komora zadana",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 3,
    "nazwa": "Wsad zadany",
    "ukryty": false,
    "zimny": false
  }
] as const;

/** Nazwy kodów firmware dla człowieka (programy, fazy - Type.Names); kod spoza słownika bez zmian. */
export const NAZWY_WEDZARNIA2: Readonly<Record<string, string>> = {"GOTOWE":"Gotowe","KIELBASA":"Kiełbasa","KONIEC":"Koniec","KONTROLA":"Kontrola","KRAKOWSKA":"Krakowska","MANUAL":"Tryb ręczny","OCIEKANIE":"Ociekanie","OSUSZANIE":"Osuszanie","PIECZENIE":"Pieczenie","PRZEPIS":"Przepis","ROZGRZEW":"Rozgrzewanie","ROZGRZEW.":"Rozgrzewanie","ROZGRZEWANIE":"Rozgrzewanie","ROZPALANIE":"Rozpalanie","RYBA":"Ryba","STOP":"Stop","SZYNKA":"Szynka","WEDZENIE":"Wędzenie","WLASNY":"Program własny"};

/** Parametry sztuki od klienta (GET/PATCH /brama/urzadzenia/{sn}/sprzet): klucz → zakres i krok liczby
 *  albo lista wartości tekstu. */
export const SPRZET_WEDZARNIA2 = {
  "heater_kw": {
    "min": 0,
    "max": 25.5,
    "krok": 0.1
  },
  "insulated": {
    "min": 0,
    "max": 1,
    "krok": 1
  },
  "smoke_gen_type": {
    "wybor": [
      "dymbox",
      "dymbox_max",
      "borniak",
      "thermowind",
      "inny"
    ]
  },
  "volume_l": {
    "min": 0,
    "max": 65535,
    "krok": 1
  }
} as const;

